import {
  FETCHING_INTEGRATIONS_REQUEST, FETCHING_INTEGRATIONS_SUCCEDDED, FETCHING_INTEGRATIONS_FAILED
} from 'constants/actionTypes';

import { createAction } from 'redux-actions';
import axios from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import _ from 'lodash';

const apiUrl = process.env.REACT_APP_API_URL;
const INTEGRATIONS_BASE_URL = `${apiUrl}/api/2.0/integrations`;

/*
* Fetch integrations
*/
export const fetchIntegrations = createAction(FETCHING_INTEGRATIONS_REQUEST);
const fetchingIntegrationsSucceeded = createAction(FETCHING_INTEGRATIONS_SUCCEDDED);
const fetchingIntegrationsFailed = createAction(FETCHING_INTEGRATIONS_FAILED);

function* fetchIntegrationsSaga(action) {
  
  const fetchIntegrationsAPI = () => {
    return axios.get(INTEGRATIONS_BASE_URL).then(response => response.data);
  }

  try {
    const response = yield call(fetchIntegrationsAPI);
    yield put(fetchingIntegrationsSucceeded(response));
  } catch (error) {
    yield put(fetchingIntegrationsFailed(error));
  }
}

export function getIntegration(integrations, type) {
  if (_.size(integrations) > 0) {
    let integration = integrations.filter(item => {
      return item != null;
    })
    .find(item => {
      return item.type === type;
    });
    return integration;
  }
  return null;
}

export default function* integrationsSaga() {
  yield takeLatest(FETCHING_INTEGRATIONS_REQUEST, fetchIntegrationsSaga);
};